import {useOktaAuth} from "@okta/okta-react";
import axios from "axios";
import config from "./config";

let logoutFunction;
export const useAuthConfig = () => {
    const {authState} = useOktaAuth();
    const authAxios = axios.create({
        baseURL: config.apiBaseURI,
        headers: {
            'Authorization': `Bearer ${authState.accessToken?.accessToken}`,
            'content-type': 'application/json',
            'Accept': 'application/json'
        }
    });

    return authAxios;
}

/**
 * Only used by pa-user-session.class
 * @param {Function} logout The function to force a logout.
 * @returns {undefined}
 */
export const setLogoutFunction = (logout) => {
    logoutFunction = logout;
}

/**
 * Only used by pa-user-session.class and the services.
 * @returns {logout}
 */
export function getLogoutFunction() {
	return logoutFunction;
}
